export enum StudentWarningsObservationDetailsGroupType {
  StudentFile = 'studentFile',
  Observation = 'observation',
}

export type StudentWarningsObservationDetailsParams = {
  studentId: string;
  studyPlanEnrollmentId: string;
  periodId: string;
  year: string;
};

export type StudentWarningObservationRow = {
  studyPlanEnrollmentId: number;
  name: string;
  identification: string;
  studyPlan: string;
  campus: string;
  promo: string;
  course: string;
};

export type StudentWarningObservationDetailsResponse = StudentWarningObservationRow;
